export const subcategoryTabs = {
    warnings: 1,
    comments: 2,
    flags: 3,
    documents: 4
};